import { useEffect } from 'react';

const DEFAULT_TITLE = 'XDOME - ';

export const useDocumentTitle = (title: string) => {
  useEffect(() => {
    document.title = `${DEFAULT_TITLE}${title}`;
    // Reset the title when the component unmounts
    return () => {
      document.title = DEFAULT_TITLE.trim();
    };
  }, [title]);
};
